import React, {useRef} from 'react';
import {useLocaleKeys} from '../../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../../Widget/ControllerContext';
import {classes} from './CustomerDetailsOpen.st.css';
import {CustomerDetailsStepDataHook} from '../CustomerDetailsStep';
import {StatesButtonStates} from 'wix-ui-tpa/cssVars';
import {ADD_NEW_ADDRESS_ID} from '../../../../constants';
import {useCustomerDetailsData} from '../WithCustomerDetailsData/WithCustomerDetailsData';
import {CustomerDetailsForm} from '../CustomerDetailsForm/CustomerDetailsForm';
import {MemberDetails} from '../../../../MemberDetails/MemberDetails';
import {DetailsFormButtons} from '../../../StepsManager/Components/DetailsFormButtons/DetailsFormButtons';
import {useContinueButtonState} from '../../../StepsManager/Components/DetailsFormButtons/UseContinueButtonState';
import {useMemberDetailsData} from '../../../../MemberDetails/WithMemberDetailsData';

export enum CustomerDetailsDataHook {
  customerDetailsForm = 'CustomerDetails.customerDetailsForm',
  disabledMemberEmail = 'CustomerDetails.disabledMemberEmail',
  temporaryEmailForSubscriptionABTest = 'CustomerDetails.temporaryEmailForSubscriptionABTest',
  subscriptionCheckbox = 'CustomerDetails.subscriptionCheckbox',
  subscriptionLabel = 'CustomerDetails.subscriptionLabel',
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export const CustomerDetailsOpen = () => {
  const sectionRootRef = useRef<HTMLDivElement>(null);
  const localeKeys = useLocaleKeys();
  const {
    checkoutStore: {submitCustomerDetails, cart, isShippingFlow, onInvalidDetailsFormSubmit},
    memberStore: {isMember, isAddressesAppInstalled},
  } = useControllerProps();

  const {isFormValid, getCustomerDetailsForSubmit} = useCustomerDetailsData();
  const {selectedAddressesServiceId, isAddNewChecked, isSetAsDefaultChecked} = useMemberDetailsData();

  const {continueButtonState, isContinueButtonDisabled, setContinueButtonState, setIsContinueButtonDisabled} =
    useContinueButtonState();

  const validateAndSubmit = async () => {
    setIsContinueButtonDisabled(true);
    setContinueButtonState(StatesButtonStates.IN_PROGRESS);

    const isValid = await isFormValid();

    if (isValid) {
      const deliveryAddressId = isAddNewChecked ? ADD_NEW_ADDRESS_ID : selectedAddressesServiceId;
      void submitCustomerDetails({
        ...getCustomerDetailsForSubmit(),
        deliveryAddressId: isShippingFlow ? deliveryAddressId : undefined,
        setAsDefault: isSetAsDefaultChecked,
      });
    } else {
      onInvalidDetailsFormSubmit();
      setIsContinueButtonDisabled(false);
      setContinueButtonState(StatesButtonStates.IDLE);
    }
  };

  const scrollToSectionRoot = () => {
    sectionRootRef?.current?.scrollIntoView({block: 'start'});
  };

  return (
    <div data-hook={CustomerDetailsStepDataHook.open} className={classes.root} ref={sectionRootRef}>
      {isMember && isAddressesAppInstalled && isShippingFlow ? (
        <MemberDetails
          Form={() => <CustomerDetailsForm />}
          dropdownLabel={localeKeys.chooseAddressModal.shipping_address_title()}
          customField={cart.customField}
        />
      ) : (
        <CustomerDetailsForm />
      )}
      <DetailsFormButtons
        onCancel={scrollToSectionRoot}
        onContinue={() => void validateAndSubmit()}
        continueButtonDisabled={isContinueButtonDisabled}
        continueButtonState={continueButtonState}
        shouldIncludeCancelButton={isShippingFlow}
      />
    </div>
  );
};
